// extracted by mini-css-extract-plugin
export default {"container":"styles_container__-AnuD","header":"styles_header__cTHEV","title":"styles_title__ieeKt","content":"styles_content__HWR4Y"};